import React from "react";
import { useTranslation } from "react-i18next";
import NewsletterStatusPage from "./NewsletterStatusPage";

const NewsletterUnsubscribedPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <NewsletterStatusPage
      path="/newsletter/unsubscribed"
      pageTitle={t("newsletter.unsubscribedTitle")}
      seoTitle={t("newsletter.unsubscribedTitle")}
      seoDescription={t("newsletter.unsubscribedMessage")}
      icon="👋"
      heading={t("newsletter.unsubscribedHeading")}
      message={t("newsletter.unsubscribedMessage")}
    />
  );
};

export default NewsletterUnsubscribedPage;
